import usePrevious from './usePrevious'

function useDidChange<T extends unknown>(value: T, defaultValue?: T) {
  const previous = usePrevious(value, defaultValue)
  return value !== previous
}

export default useDidChange
